module.exports = __webpack_public_path__ + "img/request-validated.cf1fc1b7.png";